import React from 'react';
import { Navigate, useOutlet } from 'react-router-dom';

import { RoutingPaths, RoutingViews } from '@core/services/routingService';
import { useAuth } from '@providers/authProvider';

const UnprotectedRoute: React.FC = () => {
  const { userAccount } = useAuth();
  const outlet = useOutlet();

  return userAccount ? (
    <Navigate to={RoutingPaths[RoutingViews.HOME]} />
  ) : (
    <React.Fragment>{outlet}</React.Fragment>
  );
};
export default UnprotectedRoute;
